class Geocoder {
  geocodeAddress (address) {
    return new Promise((resolve, reject) => {
      if (!this._geocoder) this._geocoder = new window.google.maps.Geocoder()
      this._geocoder.geocode({ address: address }, (res, status) => {
        if (res) {
          resolve(res[0])
        } else {
          resolve(null)
        }
      })
    })
  }

  getBoundsData (bounds) {
    const center = bounds.getCenter()
    const northEast = bounds.getNorthEast()
    const southWest = bounds.getSouthWest()
    const outerRadius = window.google.maps.geometry.spherical.computeDistanceBetween(northEast, center)
    const innerRadius = Math.sqrt(2 * Math.pow(outerRadius, 2)) / 2

    return {
      center: {
        latitude: center.lat(),
        longitude: center.lng()
      },
      northEast: {
        latitude: northEast.lat(),
        longitude: northEast.lng()
      },
      southWest: {
        latitude: southWest.lat(),
        longitude: southWest.lng()
      },
      innerRadius,
      outerRadius
    }
  }

  buildBounds ({ neLatitude, neLongitude, swLatitude, swLongitude } = {}) {
    if (
      neLatitude !== undefined &&
      neLongitude !== undefined &&
      swLatitude !== undefined &&
      swLongitude !== undefined
    ) {
      const northEast = new window.google.maps.LatLng(neLatitude, neLongitude)
      const southWest = new window.google.maps.LatLng(swLatitude, swLongitude)
      return new window.google.maps.LatLngBounds(southWest, northEast)
    }
  }
}

export default new Geocoder()



// WEBPACK FOOTER //
// ./front/apps/shared/javascripts/public_framework/services/google_geocoder.js